import React from "react";
import classes from "./Modal.module.css";

type ModalProps = {
    extraClasses?: string;
};

const Modal: React.FC<ModalProps> = (props) => {
    return (
        <div className={[classes.Modal, props.extraClasses].join(" ")}>
            <div>{props.children}</div>
        </div>
    );
};

export default Modal;
